import React from 'react';
import { slide as ReactBurgerMenu } from 'react-burger-menu';
import { Link } from 'react-router-dom';
import Radium from 'radium';

import { md } from '../utilities/styles';

const burgerMenuContainerStyles = {
  zIndex: 3000,
  position: "relative",
};

md(burgerMenuContainerStyles, {display: 'none'});

const Menu = () => {

  return (
    <div style={burgerMenuContainerStyles}>
      <ReactBurgerMenu right isOpen={false}>
        <Link className="menu-item" to="/about">About</Link>
        <Link className="menu-item" to="/humanly">Humanly</Link>
        <Link className="menu-item" to="/news">Co-op News</Link>
        <a className="menu-item" href="http://eepurl.com/diY0E5" target="_blank" rel="noopener noreferrer">Request Humanly</a>
        <a href="http://eepurl.com/did_aT" className="menu-item" target="_blank" rel="noopener noreferrer">Subscribe</a>
      </ReactBurgerMenu>
    </div>
  )
};

export default Radium(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu.js